import { Divider, FormControl, Grid, InputAdornment, InputLabel, TextField, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { MarkupEditor, parseContentToParagraph, parseKeywords } from '../../../markupEditor'
import { Info } from '@phosphor-icons/react'

export default function PronounciationSummary({ chapterData, sectionData, isValidMarkup, onContentSave, handleChange, setChapterData, onSave }) {

    useEffect(() => {
        if (chapterData) {
            let chapterDetails = {
                ...chapterData,
                contentType: 'Text'
            }
            setChapterData(chapterDetails);
            onSave(chapterDetails);
        }
    }, [])

    useEffect(() => {
        if (sectionData && !chapterData?.content && !chapterData?.keyWords) {
            const storyChapter = sectionData?.chapters?.find((chap) => chap.chapterType === "Story with Keywords");
            if (storyChapter) {
                const content = storyChapter?.content;
                const keyWords = storyChapter?.keyWords;
                const chapterDetails = {
                    ...chapterData,
                    content: content,
                    keyWords: keyWords
                }
                setChapterData(chapterDetails)
                onSave(chapterDetails)
            }
        }
    }, [])

    return (
        <>
            {/* {showTextInput && !isValidMarkup && <Grid item xs={12}>
                <InputLabel style={styles.inputLabel}>Content</InputLabel>
                <FormControl fullWidth>
                    <TextField
                        name="content"
                        value={chapterData.content}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        rows={3}
                    />
                </FormControl>
            </Grid>} */}
            {/* {showTextInput && isValidMarkup && ( */}
            <Grid item xs={12}>
                <Divider sx={{ pt: 2 }} />
                <MarkupEditor
                    onSave={onContentSave}
                    content={chapterData.content}
                    keyWords={chapterData.keyWords}
                    irLevels={Array.from(new Array(9)).map((e, i) => `L${i}`)}
                    noExtract={true}
                />
                <Divider sx={{ py: 2 }} />
            </Grid>
            {/* )} */}

            {/* {!isValidMarkup && <Grid item xs={12}>
                <InputLabel style={styles.inputLabel}>Keywords</InputLabel>
                <TextField
                    name="keyWords"
                    fullWidth
                    multiline
                    rows={3}
                    value={chapterData.keyWords}
                    onChange={handleChange}
                    placeholder="Enter Keyword"
                    required

                    InputProps={{
                        endAdornment: (
                            <InputAdornment sx={{ cursor: "pointer" }} position="end">
                                <Tooltip title="Enter the keywords, separated by commas (e.g., keyword1, keyword2, ...).">
                                    <Info />
                                </Tooltip>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>} */}
        </>
    )
}

const styles = {
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
}
